import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import './PreviewSegment.css';
import BackButton from '../../../../../BackButton';
import axiosInstance from '../../../../../../interceptor/axiosInstance';
import image from "../../../../../../Assets/preview.png";

// Skeleton Card Component
const SkeletonCard = () => (
  <div className="preview-segment-skeleton-card">
    <div className="preview-segment-skeleton-image"></div>
    <div className="preview-segment-skeleton-title"></div>
  </div>
);

// Empty State Component
const EmptyState = () => (
  <div className="preview-segment-empty-state">
    <div className="preview-segment-empty-icon">📂</div>
    <h3 className="preview-segment-empty-title">No Segments Available</h3>
    <p className="preview-segment-empty-message">
      This assessment doesn't have any segments yet.
    </p>
  </div>
);

const PreviewSegment = () => {
    const location = useLocation();
    const { testData } = location.state || {};
    const navigate = useNavigate();
    const [segments, setSegments] = useState([]);
    const [loading, setLoading] = useState(true); // Loader state

    useEffect(() => {
        if (testData) {
            setLoading(true);
            axiosInstance.get(`assessments/tests/${testData}/`)
                .then(response => {
                    setSegments(response.data.data?.segments || []);
                    setLoading(false);
                })
                .catch(error => {
                    console.error("Error fetching segments:", error);
                    setLoading(false);
                });
        }
    }, [testData]);

    const handleClick = (test) => {
        navigate(`/preview-question`, { state: { testId: test.id } });
    };

    return (
        <div className="preview-segment-container">
            {/* Header */}
            <div className="preview-segment-header">
                <div className="preview-segment-header-left">
                    <BackButton />
                    <h1 className="preview-segment-title">Assessment Segments</h1>
                    {!loading && segments.length > 0 && (
                        <span className="preview-segment-count-badge">
                            {segments.length} {segments.length === 1 ? 'Segment' : 'Segments'}
                        </span>
                    )}
                </div>
            </div>

            {/* Content */}
            {loading ? (
                <div className="preview-segment-grid">
                    {Array.from({ length: 6 }).map((_, idx) => (
                        <SkeletonCard key={idx} />
                    ))}
                </div>
            ) : segments.length > 0 ? (
                <div className="preview-segment-grid">
                    {segments.map((test) => (
                        <div 
                            key={test.id} 
                            className="preview-segment-card"
                            onClick={() => handleClick(test)}
                        >
                            <div className="preview-segment-image-wrapper">
                                <img 
                                    src={test.thumbnail && test.thumbnail.trim() !== "" ? test.thumbnail : image} 
                                    alt={test.name} 
                                    className="preview-segment-image"
                                    onError={(e) => { e.target.src = image; }}
                                />
                                <div className="preview-segment-overlay">
                                    <span className="preview-segment-view-icon">👁️</span>
                                    <span className="preview-segment-view-text">Preview Questions</span>
                                </div>
                            </div>
                            <div className="preview-segment-card-body">
                                <h2 className="preview-segment-card-title">{test.name}</h2>
                            </div>
                        </div>
                    ))}
                </div>
            ) : (
                <EmptyState />
            )}
        </div>
    );
};

export default PreviewSegment;
